import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React from 'react';
import PropTypes from 'prop-types';
import { DSIconSizes, DSIconColors } from '@elliemae/ds-basic/Icon';
import DatePicker from '@elliemae/ds-icons/DatePicker';
import DSButton, { buttonTypes } from '@elliemae/ds-basic/Button';
import { a as iconSizes } from '../../prop-types-8c5debac.js';

var Picker = function Picker(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? 'date-picker-icon' : _ref$className,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? /*#__PURE__*/React.createElement(DatePicker, null) : _ref$icon,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? DSIconSizes.M : _ref$size,
      _ref$buttonActionType = _ref.buttonActionType,
      buttonActionType = _ref$buttonActionType === void 0 ? 'secondary' : _ref$buttonActionType,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {
    return null;
  } : _ref$onClick,
      _ref$onBlur = _ref.onBlur,
      onBlur = _ref$onBlur === void 0 ? function () {
    return null;
  } : _ref$onBlur,
      _ref$readOnly = _ref.readOnly,
      readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly,
      _ref$tabIndex = _ref.tabIndex,
      tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex,
      innerRef = _ref.innerRef,
      rest = _objectWithoutProperties(_ref, ["className", "disabled", "icon", "size", "buttonActionType", "onClick", "onBlur", "readOnly", "tabIndex", "innerRef"]);

  return /*#__PURE__*/React.createElement(DSButton, {
    innerRef: innerRef,
    "aria-label": rest['aria-label'] || 'Date Picker Button',
    buttonType: buttonActionType,
    className: className,
    color: !disabled ? DSIconColors.PRIMARY : DSIconColors.NEUTRAL,
    disabled: disabled,
    icon: icon,
    onBlur: onBlur,
    onClick: onClick,
    readOnly: readOnly,
    size: size,
    tabIndex: tabIndex,
    "data-testid": "btn-date-picker"
  });
};
var PickerPropsTypes = {
  innerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.any
  })]),
  className: PropTypes.string,
  disabled: PropTypes.bool,
  icon: PropTypes.element,
  size: PropTypes.oneOf(iconSizes),
  buttonActionType: PropTypes.oneOf(buttonTypes),
  onClick: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  readOnly: PropTypes.bool,
  tabIndex: PropTypes.number
};
Picker.propTypes = PickerPropsTypes;

export default Picker;
export { Picker, PickerPropsTypes };
//# sourceMappingURL=DatePickerPicker.js.map
